import React, { useState, useEffect } from "react";
import {
  AccordionContent,
  AccordionContentInner,
  AccordionList,
} from "./Menu.styles";
import {
  extractCollectionData,
  getKeys,
  getCollectionsHandle,
  getProductHandle,
  getHandleCapitalize,
} from "../../../adapters";
import { LinkDecorated } from "../../Typography";
export const CollectionMenu = ({
  handle,
  openItem,
  catTiers,
  collectionScrollContentRef,
  setSubPage,
  setPage,
  setActive,
}) => {
  const _open = openItem === "categories";
  const collectionsHandle = getCollectionsHandle(handle);
  const productHandle = getProductHandle(handle);
  const handleCapitalize = getHandleCapitalize(handle);

  const [list, _setList] = useState(
    extractCollectionData({
      values: catTiers[handleCapitalize],
      level: 0,
      collection: collectionsHandle,
    })
  );
  const [_expand, setExpanded] = useState(false);

  const expandList = (v) => {
    v.expanded = !v.expanded;
    setExpanded((t) => !t);
  };

  useEffect(() => {
    const v = list?.values.filter((tags) => tags.collection === productHandle);
    if (v.length) {
      v[0].expanded = !v[0].expanded;
      setExpanded((t) => !t);
      setSubPage && setSubPage("categories");
      setPage && setPage(2);
    }
  }, []);

  const displayChildrenMenu = ({ child, isExpanded }) => {
    return child?.values.map((i) => {
      return (
        isExpanded && (
          <AccordionContent key={i.name} onClick={() => expandList(i)}>
            <AccordionList marginLeft={10 * i.level}>
              <LinkDecorated
                activeStyle={{
                  fontWeight: 700,
                  borderBottom: "1px solid white",
                }}
                to={`/collections/${i.collection}`}
                onClick={() => {
                  setActive && setActive(false);
                }}
              >
                {i.name}
              </LinkDecorated>
            </AccordionList>
            {displayChildrenMenu({
              child: i.children,
              isExpanded: i.expanded,
            })}
          </AccordionContent>
        )
      );
    });
  };

  const renderCategories = () => {
    return list?.values.map((tag, i) => {
      return (
        <div key={i}>
          <AccordionList onClick={() => expandList(tag)}>
            <LinkDecorated
              activeStyle={{
                fontWeight: 700,
                borderBottom: "1px solid white",
              }}
              to={`/collections/${tag.collection}`}
            >
              {tag.name}
            </LinkDecorated>
          </AccordionList>

          {displayChildrenMenu({
            child: tag.children,
            isExpanded: tag.expanded,
          })}
        </div>
      );
    });
  };

  return (
    <>
      <AccordionContent>
        <AccordionContentInner>
          <div ref={collectionScrollContentRef}>
            {renderCategories(catTiers)}
          </div>
        </AccordionContentInner>
      </AccordionContent>
    </>
  );
};
